import Utils from '@/core/utils'
import StorageUtils from '@/core/storageUtils'
import Store from '@/store'

const platform = Utils.getUrlQuery('platform') || StorageUtils.sessionStorage.get('platform') || 'web'

function tracks(originParams) {
  // const platform = store.getters.platform
  // originParams 必须由event和params组成
  try {
    if (platform === 'web') {
      // 走web端打点
      this.$api.tracks(originParams)
    } else {
      /**
       * clientType: string,
         hostAppName: string,
          hostAppVersion: string,
          desktopName: string,
          desktopVersion: string,
          machineCode: string,
          osVersion: string,
          screenResolutions: string
      */
      const info = StorageUtils.sessionStorage.get('desktopInfo')
      const user = Store.state.user.user || {}
      const headers = user.strId ? {
        'local-user-agent': 'Mozilla/5.0',
        'local-os': info.osVersion,
        'local-resolution': info.screenResolutions,
        'local-plugin-version': info.desktopVersion,
        'local-host': info.hostAppName,
        'local-machine-code': info.machineCode,
        'local-app-version': info.hostAppVersion,
        'local-access-token': Store.state.user.userToken,
        'local-uid': user.strId,
        'local-host-version': info.hostAppVersion,
      } : {}
      this.$api.tracks(originParams, headers)
    }
  } catch (error) {
    console.log('打点失败', error)
  }
}

export default {
  install: (Vue) => {
    Vue.prototype.$tracks = tracks
  },
  inject: (Store) => {
    Store.prototype.$tracks = tracks
  }
}
